<div class="position-relative h-100 d-flex flex-column">
    <app-section-loader [loading]="loading"></app-section-loader>
    <h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">{{dialogDataInstance.title}}</h2>
    <mat-dialog-content>
        <div>
            <p class="modal-text m-0">Why are {{dialogDataInstance?.studentList?.length}} of
                {{dialogDataInstance?.totalStudentsCount}} students being made inactive?</p>
            <mat-radio-group [(ngModel)]="bulkActionBody.why_inactive" class="mt-1 mb-4" style="display:grid">
                <mat-radio-button *ngFor="let status of inactiveStatus" [value]="status">
                    {{status | titlecase}}
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-form-field class="w-100 no-error" appearance="outline">
            <mat-label>Notes</mat-label>
            <textarea matInput cdkTextareaAutosize placeholder="Add notes" [(ngModel)]="bulkActionBody.notes"
                #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="8" cdkAutosizeMaxRows="8"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="!bulkActionBody.why_inactive"
            (click)="confirmAction()">Save</button>
    </mat-dialog-actions>
</div>